import axios from '@/libs/axios'
import {handleCatch, mapDropdown} from '@/utils'
import {ApiCode, ApiExtRoutes} from '@/const/api'
import {defaultParams} from '@/store/common/dropdown';

export default {
    async getYears(params) {
        try {
            const response = await axios.get('categories/factYears', { params })
            const { data } = response
            if (data.code === ApiCode.SUCCESS) {
                const { records } = data.data
                return records
            }
        } catch (e) {
            handleCatch(e)
        }
        return []
    },
}
